/**
 * Wisecure Design System — Color Tokens
 *
 * Mirrors the Flutter DS color families (packages/presentation/design_system/lib/colors.dart).
 *
 * Shade usage guidelines:
 * - 50–200: backgrounds and surfaces
 * - 400: primary action color (Base)
 * - 600–700: text on light fills
 *
 * Text on color:
 * - On shades 400+: use white
 * - On shades 50–300: use black
 */

export const neutral = {
  0: '#FFFFFF',
  50: '#F5F6F7',
  100: '#E5E7EA',
  200: '#C8CDD4',
  300: '#9AA2AC',
  500: '#5A6472',
  700: '#2D3440',
  900: '#111318',
} as const;

export const primary = {
  50: '#F0F7FF',
  100: '#D4E6F7',
  200: '#A8CEEF',
  300: '#7DB4E5',
  400: '#0B5394',
  500: '#084284',
  600: '#063272',
  700: '#042153',
} as const;

export const error = {
  50: '#FEF0EF',
  100: '#FFCFCD',
  200: '#F9A09C',
  300: '#F56D68',
  400: '#E83430',
  500: '#C42420',
  600: '#9E1A17',
  700: '#6B0F0D',
} as const;

export const success = {
  50: '#EEFAF3',
  100: '#C6EDD6',
  200: '#8DD6B0',
  300: '#4DB87F',
  400: '#1C9E5A',
  500: '#15864B',
  600: '#0D6B3A',
  700: '#074526',
} as const;

export const warning = {
  50: '#FEF6EC',
  100: '#FCE4C0',
  200: '#F9C980',
  300: '#F5A030',
  400: '#E07B00',
  500: '#BE6700',
  600: '#985200',
  700: '#633500',
} as const;

export const info = {
  50: '#E6F2F8',
  100: '#BDD9EC',
  200: '#7FB8D9',
  300: '#4099C2',
  400: '#0085B2',
  500: '#00729A',
  600: '#005D80',
  700: '#003D54',
} as const;

export const purple = {
  50: '#F5F3FF',
  100: '#EDE9FE',
  200: '#DDD6FE',
  300: '#C4B5FD',
  400: '#A855F7',
  500: '#9333EA',
  600: '#7E22CE',
  700: '#581C87',
} as const;

export const semantic = {
  white: '#FFFFFF',
  black: '#000000',
  shadow: 'rgba(0, 53, 127, 0.08)',
  darkBlue: '#00357F',
} as const;
